export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-Latin2-973620d1c4e67416793d1868f03b609a.woff2";